import pageHelper from "./PageHelper";

//import "./dSigXadesBp.min.js";
//import "./dCommon.min.js";

//import { dtc } from "../dtc-options.js";
import { generateGuid } from "@/helpers/Component";

export default class Signer {
  public static ditec: { [key: string]: any } = window.ditec;
  public static addXmlObjectConfig: Array<any> = [];
  public static signerIdentification: string = "";
  public static resolve: any = null;
  public static reject: any = null;
  public static podpisTexts = {
    dSignerMessageTitle: "",
    zrusit: "",
    dSignerMessageDescription: "",
    chybaDSigner: "",
  };
  // public static callback = (success: any) => {
  //   this.onSuccess = success;
  //   if (this.onSuccess == null) {
  //     this.onSuccess = function (value) {
  //       alert("Hodnota:\n" + value);
  //     };
  //   }
  // };
  public static newCallback(success?: (() => any) | ((param:string) => any)) {
    const callback = {
      onSuccess: success,
      onError: function (e: any) {
        console.log("We are now in the error territory",e);
        //Signer.reject();

        //self.reject();
        if (Signer.ditec.utils.isDitecError(e)) {
          if (e.code === Signer.ditec.utils.ERROR_CANCELLED) {
            //gf.dbg("prerusene pouzivatelom");
            pageHelper.removeOverlay();
          } else {
            let logRequest = {
              LogLevel: "e",
              Message: `D.Signer  ${e.code} - ${e.message}`,
              Usage: `Page:\r\n${window.location.href}\n\n\nMethod:\nD.Viewer\n\n\nError:\n${e.code}-${e.message}\n\n`,
              CorrelationId: window.correlationID,
            };
            //gf.logMessage(logRequest);
            //gf.dbg("" + e.code + ": " + e.message);
            pageHelper.addPanelBox(null, "e", { text: Signer.podpisTexts.chybaDSigner });
            pageHelper.removeOverlay();
          }
        } else {
          let logRequest = {
            LogLevel: "e",
            Message: `D.Signer  ${e.code} - ${e.message}`,
            Usage: `Page:\r\n${window.location.href}\n\n\nMethod:\nD.Viewer\n\n\nError:\n${e.code}-${e.message}\n\n`,
            CorrelationId: window.correlationID,
          };
          //gf.logMessage(logRequest);
          //gf.dbg("" + e.code + ": " + e.message);
          pageHelper.addPanelBox(null, "e", { text: Signer.podpisTexts.chybaDSigner });
          pageHelper.removeOverlay();
        }
      },
    };
    return callback;
    //console.log("before newCallback", Signer.reject);
    // return new Promise(async (onSuccess, onFailure) => {
    //   try {
    //     await success();
    //   } catch (e: any) {
    //     console.log("We are now in the error territory");
    //     //Signer.reject();

    //     //self.reject();
    //     if (Signer.ditec.utils.isDitecError(e)) {
    //       if (e.code === Signer.ditec.utils.ERROR_CANCELLED) {
    //         //gf.dbg("prerusene pouzivatelom");
    //         pageHelper.removeOverlay();
    //       } else {
    //         let logRequest = {
    //           LogLevel: "e",
    //           Message: `D.Signer  ${e.code} - ${e.message}`,
    //           Usage: `Page:\r\n${window.location.href}\n\n\nMethod:\nD.Viewer\n\n\nError:\n${e.code}-${e.message}\n\n`,
    //           CorrelationId: window.correlationID,
    //         };
    //         //gf.logMessage(logRequest);
    //         //gf.dbg("" + e.code + ": " + e.message);
    //         pageHelper.addPanelBox(null, "e", { text: Signer.podpisTexts.chybaDSigner });
    //         pageHelper.removeOverlay();
    //       }
    //     } else {
    //       let logRequest = {
    //         LogLevel: "e",
    //         Message: `D.Signer  ${e.code} - ${e.message}`,
    //         Usage: `Page:\r\n${window.location.href}\n\n\nMethod:\nD.Viewer\n\n\nError:\n${e.code}-${e.message}\n\n`,
    //         CorrelationId: window.correlationID,
    //       };
    //       //gf.logMessage(logRequest);
    //       //gf.dbg("" + e.code + ": " + e.message);
    //       pageHelper.addPanelBox(null, "e", { text: Signer.podpisTexts.chybaDSigner });
    //       pageHelper.removeOverlay();
    //     }
    //   }
    // });
  }

  public sign(xml: string, xsd: string, xsl: string, objectDescription: string) {
    let promise = new Promise((resolve, reject) => {
      Signer.reject = reject;
      Signer.resolve = resolve;
      try {
        pageHelper
          .dViewerOpeningDialog(Signer.podpisTexts.dSignerMessageTitle, Signer.podpisTexts.zrusit, Signer.podpisTexts.dSignerMessageDescription)
          .then(() => {
            Signer.ditec.dSigXadesBpJs.deployCancel(Signer.newCallback(() => {}));
          });

        //zistit co ide do version (v prihlaskach tam bol HlavnyRozpracovanyObjekt.XdcVersion)
        const version = "1";
        //zistit co ide do version (v prihlaskach tam bol HlavnyRozpracovanyObjekt.XdcIdentifier)
        const identifier = generateGuid();
        console.log(xml,xsd);
        //Integračné API - 18 / 25 - addXmlObject
        Signer.addXmlObjectConfig = [
          generateGuid(), //objectId
          objectDescription, //objectDescription
          window.pID, //objectFormatIdentifier (xml namespace)
          xml, //xdcXMLData
          identifier, //xdcIdentifier
          version, //xdcVersion
          xsd, //xdcUsedXSD
          "http://www.ditec.sk/xsdReference", //xsdReferenceURI
          xsl, //xdcUsedXSLT
          "http://www.ditec.sk/xslReference", //xslReferenceURI
          Signer.ditec.dSigXadesBpJs.XML_MEDIA_DESTINATION_TYPE_DESC_HTML, //xslMediaDestinationTypeDescription
          Signer.ditec.dSigXadesBpJs.LANG_SK, //xslXSLTLanguage
          "targetEnvironment", //xslTargetEnvironment
          true, //UsedSchemasReferenced  xdcIncludeRefs
          Signer.ditec.dSigXadesBpJs.XML_XDC_NAMESPACE_URI_V1_1, //xdcNamespaceURI
        ];

        Signer.signerIdentification = "";

        Signer.ditec.dSigXadesBpJs.deploy(null, Signer.newCallback(Signer.deployOnSuccessCallback));
      } catch (err) {
        console.error(err);
      }
    });
    return promise;
  }
  public static getSignatureWithASiCEnvelopeBase64OnSuccessCallback(ret: string) {
    const podpis = {
      ObsahB64: ret,
      Popis: Signer.signerIdentification,
    };
    console.log("PODPIS", podpis);
    Signer.resolve(podpis);
  }
  public static b64DecodeUnicode(str : string) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(window.atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
};
// public static b64EncodeUnicode(str:string) {
//     // first we use encodeURIComponent to get percent-encoded UTF-8,
//     // then we convert the percent encodings into raw bytes which
//     // can be fed into btoa.
//     return window.btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
//         function toSolidBytes(match, p1:number) {
//             return String.fromCharCode('0x' + p1);
//         }));
// };
  public static signOnSuccessCallback() {
    console.log("on Sign succesdss");
    Signer.ditec.dSigXadesBpJs.getSignatureWithASiCEnvelopeBase64(Signer.newCallback(Signer.getSignatureWithASiCEnvelopeBase64OnSuccessCallback));
    pageHelper.removeOverlay();
  }

  public static getSignerIdentificationOnSuccessCallback(ret: string) {
    console.log("BEFORE SIGNING !~");
    Signer.signerIdentification = ret;

    //sign(signatureId, digestAlgUri, signaturePolicyIdentifier, callback)
    Signer.ditec.dSigXadesBpJs.sign(
      "signatureId",
      "http://www.w3.org/2001/04/xmlenc#sha256",
      "urn:oid:1.3.158.36061701.1.2.3",
      Signer.newCallback(Signer.signOnSuccessCallback)
    );
  }

  public static addXmlObjectOnSuccessCallback() {
    Signer.ditec.dSigXadesBpJs.getSignerIdentification(Signer.newCallback(Signer.getSignerIdentificationOnSuccessCallback));
  }

  public static initializeOnSuccessCallback() {
    console.log("INIT SUCCESS");
    Signer.addXmlObjectConfig.push(Signer.newCallback(Signer.addXmlObjectOnSuccessCallback));
    Signer.ditec.dSigXadesBpJs.addXmlObject(...Signer.addXmlObjectConfig);
  }

  public static deployOnSuccessCallback() {
    console.log("DEPLOY SUCCESS");
    Signer.ditec.dSigXadesBpJs.initialize( Signer.newCallback(Signer.initializeOnSuccessCallback));
  }
}
